import type { DialogContentNode } from "@/v2/framework/dialog/types";
import { getSupplementalsByEntity } from "@/services/supplementals";

type SportTranslationRow = {
  name?: string | null;
  info?: string | null;
  supplementalNames?: { supplementalNameTypeId: string; name?: string | null }[];
};

export const buildSportTranslationFields = () => {
  const nodes: DialogContentNode[] = [
    {
      type: "text-field",
      name: "name",
      label: "table_columns.name",
      placeholder: "Enter name",
    },
    {
      type: "text-field",
      name: "info",
      label: "table_columns.info",
      placeholder: "Enter info",
    },
  ];

  const supplementalNameTypes = getSupplementalsByEntity("SPORT");
  for (const supplementalNameType of supplementalNameTypes) {
    nodes.push({
      type: "text-field",
      name: `supplementalName_${supplementalNameType.id}`,
      label: `table_columns.${supplementalNameType.name.toLowerCase()}`,
      placeholder: "Enter name",
      valueFormatter: (row: unknown) => {
        const r = row as SportTranslationRow;
        return (
          r.supplementalNames?.find(
            (s) => String(s.supplementalNameTypeId) === String(supplementalNameType.id),
          )?.name ?? ""
        );
      },
    });
  }

  return nodes;
};
